import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["BigReportButtonWebView"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/components_simple/buttons/BigReportButtonWebview.tsx");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/illustrations/company.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/illustrations/consumer.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/illustrations/dgccrf.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/illustrations/report.png");
